import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d68e7f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "header-content" })
], -1))
const _hoisted_2 = { id: "home" }
const _hoisted_3 = { id: "home-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Purchase Complete", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Please allow 2-5 business days for delivery!", -1))
const _hoisted_6 = {
  key: 0,
  id: "blorp"
}
const _hoisted_7 = ["product"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Back to Home", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_ctx.products)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.successCart, (count, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  product: key
                }, [
                  _createElementVNode("img", {
                    src: _ctx.getImage(key)
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          id: "homeLink",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ])
  ]))
}